
const Iletisim = () => {
  return (
    <>
      <div className="row justify-content-center mb-4 pt-4 pb-4">
        <div className="col-md-5 col-sm-12 d-flex flex-column">
          <h2 className="header-hero-contact pb-4">POLSAN Teknokent</h2>

          <div className="row justify-content-between mb-4">
            <div className="col mt-4">
              <p>POLSAN Teknoloji Geliştirme Bölgesi İstanbul, Tuzla - Akfırat bölgesinde yapılandırılmaktadır. Kuzey Marmara Otoyolu’na 2 km, Sabiha Gökçen Havalimanı’na 10 km, Osman Gazi Köprüsü’ne 25 km ve Fatih Sultan Mehmet Köprüsü’ne 35 km mesafede yer almaktadır.</p>
            </div>
          </div>

          <div className="row justify-content-between mt-auto">
            <div className="google-map col">
              <iframe src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d6029.646844692592!2d29.4210195!3d40.9196174!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDDCsDU1JzEwLjciTiAyOcKwMjUnMjIuNiJF!5e0!3m2!1sen!2str!4v1768227614455!5m2!1sen!2str" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
        
        <div className="col-md-1"></div>
        <div className="col-md-1 border-start"></div>
        
        <div className="col-md-5 col-sm-12 d-flex flex-column">
          <h2 className="header-hero-contact pb-4">Genel Müdürlük</h2>

          <div className="row justify-content-between mb-4">
            <div className="col mt-4 pb-1">
              <p className="mb-0"><i className="bi bi-pin-map-fill"></i> Ünalan Mahallesi Libadiye Caddesi No: 84 34700 </p>
              <p className="mb-1 text-end">Üsküdar / İSTANBUL</p>
              <p className="mb-1"><i className="bi bi-telephone-fill"></i> <a href="tel:+902162101842">+90 216 210 18 42</a></p>
              <p className="mb-1"><i className="bi bi-envelope-fill"></i> <a href="mailto:info@polsanteknokent.com.tr" aria-label="info@polsanteknokent.com.tr adresine e-posta gönder">info@polsanteknokent.com.tr</a></p>
            </div>
          </div>

          <div className="row justify-content-between mt-auto">
            <div className="google-map col">
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.1356508020917!2d29.068104090130312!3d41.000404046052054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac7dc2527cb6f%3A0x78c0b47807d519ac!2zw5xuYWxhbiwgTGliYWRpeWUgQ2QuIE5vOjg0LCAzNDcwMCDDnHNrw7xkYXIvxLBzdGFuYnVs!5e0!3m2!1sen!2str!4v1758793992255!5m2!1sen!2str" allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row justify-content-between mb-4 header-hero pt-4 pb-4">
        <div className="col-md-5 col-sm-12">
          <h2>POLSAN Teknokent</h2>
        </div>

        <div className="col-md-1"></div>
        <div className="col-md-1 border-start"></div>
        
        <div className="col-md-5 col-sm-12">
          <h2>Genel Müdürlük</h2>
        </div>
      </div>

      <div className="row justify-content-between mb-4">
        <div className="col-md-5 col-sm-12 mt-4">
          <p>İstanbul’un Pendik/Tuzla ilçeleri ile Gebze sanayi bölgeleri arasındaki son yerleşim bölgesinden birisi olan Akfırat/Tuzla’da yaklaşık 144 dönüm alana yapılmaktadır. POLSAN Teknokent, Kuzey Marmara Otoyolu’na 2km, Sabiha Gökçen Havalimanı’na 10 km, Osman Gazi Köprüsü’ne 25 km, Fatih Sultan Mehmet Köprüsü’ne 35 km mesafede yer almaktadır.</p>
        </div>
        
        <div className="col-md-1"></div>
        <div className="col-md-1 border-start"></div>
        
        <div className="col-md-5 col-sm-12 mt-4">
          <p><i className="bi bi-pin-map-fill"></i> Ünalan Mahallesi Libadiye Caddesi No: 84 34700 
          <p className="text-end">Üsküdar / İSTANBUL</p></p>
          <p><i className="bi bi-telephone-fill"></i> <a href="tel:+902162101842">+90 216 210 18 42</a></p>
          <p><i className="bi bi-envelope-fill"></i> <a href="mailto:basvuru@polsanteknokent.com.tr" aria-label="basvuru@polsanteknokent.com.tr adresine e-posta gönder">basvuru@polsanteknokent.com.tr</a></p>
        </div>
      </div>

      <div className="row justify-content-between mb-4">
        <div className="google-map col-md-6 col-sm-12">
          <iframe src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d6029.646844692592!2d29.4210195!3d40.9196174!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDDCsDU1JzEwLjciTiAyOcKwMjUnMjIuNiJF!5e0!3m2!1sen!2str!4v1768227614455!5m2!1sen!2str" width="600" height="450" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
       
       
        <div className="google-map col-md-6 col-sm-12 border-start">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3011.1356508020917!2d29.068104090130312!3d41.000404046052054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cac7dc2527cb6f%3A0x78c0b47807d519ac!2zw5xuYWxhbiwgTGliYWRpeWUgQ2QuIE5vOjg0LCAzNDcwMCDDnHNrw7xkYXIvxLBzdGFuYnVs!5e0!3m2!1sen!2str!4v1758793992255!5m2!1sen!2str"   style={{ border: "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>

      </div> */}
    </>
  );
};

export default Iletisim;
